import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/lib/util/colors'


Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: colors.teal.base,
        secondary: colors.purple.darken2,
        accent: colors.purple.accent4,
        error: colors.red.base,
        warning: colors.deepOrange.base,
        info: colors.indigo.base,
        success: colors.green.base
      }
    }
  }
});
